<template>
  <div class="items">
    <el-form-item
      :label="`${label}（第${i}${unit}）`"
      v-for="i in count"
      :key="i"
    >
      {{ value[i - 1] }}
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    label: String,
    unit: {
      type: String,
      default: '年'
    }
  },
  computed: {
    count() {
      return this.value?.length || 0;
    }
  }
};
</script>

<style lang="less" scoped></style>
